var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b8332a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.8,37.5h-14.6c-3.69,0-6.7-3.01-6.7-6.7v-14.6c0-3.69,3.01-6.7,6.7-6.7h14.6c3.69,0,6.7,3.01,6.7,6.7v14.6c0,3.69-3,6.7-6.7,6.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.8,37.5h-14.6c-3.69,0-6.7-3.01-6.7-6.7v-14.6c0-3.69,3.01-6.7,6.7-6.7h14.6c3.69,0,6.7,3.01,6.7,6.7v14.6c0,3.69-3,6.7-6.7,6.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.8,70.5h-14.6c-3.69,0-6.7-3.01-6.7-6.7v-14.6c0-3.69,3.01-6.7,6.7-6.7h14.6c3.69,0,6.7,3.01,6.7,6.7v14.6c0,3.69-3,6.7-6.7,6.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.8,70.5h-14.6c-3.69,0-6.7-3.01-6.7-6.7v-14.6c0-3.69,3.01-6.7,6.7-6.7h14.6c3.69,0,6.7,3.01,6.7,6.7v14.6c0,3.69-3,6.7-6.7,6.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverInactive);
export default __webpack_public_path__ + "static/media/Discover-inactive.7190b5e37fd723b9c7d3addc3c16f444.svg";
export { ForwardRef as ReactComponent };